<aside class="sidebar" [class.sidebar--consumer]="layoutVariant === 'consumer'" [class.sidebar--provider]="layoutVariant === 'provider'">
  <!-- Mobile/Tablet Navigation Bar (md devices) -->
  <div class="sidebar__mobile-bar">
    <div class="sidebar__mobile-content">
      <!-- Panel Name -->
      <div class="sidebar__mobile-panel">
        <div class="sidebar__logo">
          <img src="/icons/role-icon.svg" alt="" class="sidebar__logo-img" width="24" height="24" />
        </div>
        <h1 class="sidebar__mobile-title">{{ title || 'Consumer' }}</h1>
      </div>
      
      <!-- Active Page Selector -->
      <div class="sidebar__mobile-selector">
        <div class="sidebar__mobile-input" (click)="toggleOffcanvas()">
          <img class="menu-icon menu-icon--role" src="/icons/role-icon.svg" alt="" width="20" height="20" />
          <span class="current-page">{{ currentPageLabel }}</span>
          <svg class="chevron-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- Desktop Sidebar Header -->
  <div class="sidebar__header">
    <div class="sidebar__header-container">
      <div class="sidebar__header-content">
        <div class="sidebar__logo">
          <img src="/icons/role-icon.svg" alt="" class="sidebar__logo-img" width="24" height="24" />
        </div>
        <h1 class="sidebar__title">{{ title || 'Consumer' }}</h1>
      </div>
    </div>
  </div>

  <!-- Desktop Sidebar Navigation -->
  <nav class="sidebar__nav">
    <ul class="sidebar__menu">
      <li 
        *ngFor="let item of menuItems" 
        class="sidebar__menu-item"
        [class.has-children]="item.children && item.children.length > 0"
        [class.dropdown-open]="isDropdownOpen(item.label)"
      >
        <!-- Parent item with dropdown -->
        <div 
          *ngIf="item.children && item.children.length > 0"
          class="sidebar__menu-link sidebar__menu-link--dropdown"
          (click)="toggleItemDropdown(item.label, $event)"
        >
          <span class="sidebar__menu-icon" *ngIf="item.iconUrl || item.safeIcon">
            <img *ngIf="item.iconUrl" [src]="item.iconUrl" alt="" class="sidebar__menu-icon-img" />
            <svg *ngIf="!item.iconUrl && item.safeIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <g [innerHTML]="item.safeIcon"></g>
            </svg>
          </span>
          <span class="sidebar__menu-label">{{ item.label }}</span>
          <svg 
            class="sidebar__dropdown-arrow"
            [class.rotated]="isDropdownOpen(item.label)"
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </div>
        
        <!-- Regular link item -->
        <a 
          *ngIf="!item.children || item.children.length === 0"
          [routerLink]="item.route"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}"
          class="sidebar__menu-link"
          (click)="handleMenuClick(item)"
        >
          <span class="sidebar__menu-icon" *ngIf="item.iconUrl || item.safeIcon">
            <img *ngIf="item.iconUrl" [src]="item.iconUrl" alt="" class="sidebar__menu-icon-img" />
            <svg *ngIf="!item.iconUrl && item.safeIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <g [innerHTML]="item.safeIcon"></g>
            </svg>
          </span>
          <span class="sidebar__menu-label">{{ item.label }}</span>
        </a>
        
        <!-- Dropdown children -->
        <ul 
          *ngIf="item.children && item.children.length > 0 && isDropdownOpen(item.label)"
          class="sidebar__submenu"
        >
          <li 
            *ngFor="let child of item.children" 
            class="sidebar__submenu-item"
            [class.sidebar__submenu-separator]="!child.route && (child.label === '---' || child.label === 'separator')"
          >
            <a 
              *ngIf="child.route"
              [routerLink]="child.route"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{exact: false}"
              class="sidebar__submenu-link"
              (click)="handleMenuClick(child, $event)"
            >
              <span class="sidebar__submenu-label">{{ child.label }}</span>
            </a>
            <div 
              *ngIf="!child.route && (child.label === '---' || child.label === 'separator')"
              class="sidebar__submenu-separator-line"
            ></div>
          </li>
        </ul>
      </li>
      
      <!-- Call to Action as Menu Item -->
      <li class="sidebar__menu-item sidebar__cta-item" *ngIf="callToAction">
        <a 
          *ngIf="callToAction.linkRoute"
          [routerLink]="callToAction.linkRoute"
          [class.active]="isOrganisationRouteActive()"
          class="sidebar__menu-link sidebar__cta-link"
        >
          <span class="sidebar__menu-icon sidebar__cta-icon-wrap" *ngIf="callToAction.iconUrl || callToAction.safeIcon">
            <img *ngIf="callToAction.iconUrl" [src]="callToAction.iconUrl" alt="" class="sidebar__cta-icon-img" />
            <svg *ngIf="!callToAction.iconUrl && callToAction.safeIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <g [innerHTML]="callToAction.safeIcon"></g>
            </svg>
          </span>
          <span class="sidebar__cta-content">
            <span class="sidebar__cta-title">{{ callToAction.title }}</span>
            <span class="sidebar__cta-description">{{ callToAction.description }}</span>
            <span class="sidebar__cta-button-text">{{ callToAction.linkText }} 
              <img src="/icons/right-arrow-blue.svg" alt="right arrow" width="16" height="16"/>
            </span>
          </span>
        </a>
        <a 
          *ngIf="callToAction.linkHref && !callToAction.linkRoute"
          [href]="callToAction.linkHref"
          class="sidebar__menu-link sidebar__cta-link"
        >
          <span class="sidebar__menu-icon sidebar__cta-icon-wrap" *ngIf="callToAction.iconUrl || callToAction.safeIcon">
            <img *ngIf="callToAction.iconUrl" [src]="callToAction.iconUrl" alt="" class="sidebar__cta-icon-img" />
            <svg *ngIf="!callToAction.iconUrl && callToAction.safeIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <g [innerHTML]="callToAction.safeIcon"></g>
            </svg>
          </span>
          <span class="sidebar__cta-content">
            <span class="sidebar__cta-title">{{ callToAction.title }}</span>
            <span class="sidebar__cta-description">{{ callToAction.description }}</span>
            <span class="sidebar__cta-button-text" *ngIf="callToAction.linkText">{{ callToAction.linkText }} →</span>
          </span>
        </a>
        <div 
          *ngIf="!callToAction.linkRoute && !callToAction.linkHref"
          class="sidebar__menu-link sidebar__cta-link sidebar__cta-link--disabled"
        >
          <span class="sidebar__menu-icon sidebar__cta-icon-wrap" *ngIf="callToAction.iconUrl || callToAction.safeIcon">
            <img *ngIf="callToAction.iconUrl" [src]="callToAction.iconUrl" alt="" class="sidebar__cta-icon-img" />
            <svg *ngIf="!callToAction.iconUrl && callToAction.safeIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <g [innerHTML]="callToAction.safeIcon"></g>
            </svg>
          </span>
          <span class="sidebar__cta-content">
            <span class="sidebar__cta-title">{{ callToAction.title }}</span>
            <span class="sidebar__cta-description">{{ callToAction.description }}</span>
          </span>
        </div>
      </li>
    </ul>
    
    <!-- Divider line between CTA card and footer links -->
    <div class="sidebar__divider" aria-hidden="true"></div>
    
    <!-- Desktop Sidebar Footer (immediately below CTA card) -->
    <div class="sidebar__footer">
      <a 
        *ngFor="let item of footerItems"
        [routerLink]="item.route ? [item.route] : null"
        [href]="item.href"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{exact: false}"
        class="sidebar__footer-item"
        (click)="handleMenuClick(item)"
      >
        <span class="sidebar__footer-icon" *ngIf="item.iconUrl || item.safeIcon">
          <img *ngIf="item.iconUrl" [src]="item.iconUrl" alt="" class="sidebar__footer-icon-img" />
          <svg *ngIf="!item.iconUrl && item.safeIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <g [innerHTML]="item.safeIcon"></g>
          </svg>
        </span>
        <span class="sidebar__footer-label">{{ item.label }}</span>
      </a>
    </div>
  </nav>
</aside>

<!-- Offcanvas Menu (Mobile/Tablet) -->
<div
  class="sidebar-offcanvas"
  [class.open]="offcanvasOpen"
  [class.sidebar-offcanvas--consumer]="layoutVariant === 'consumer'"
  [class.sidebar-offcanvas--provider]="layoutVariant === 'provider'"
>
  <div class="offcanvas-backdrop" (click)="closeOffcanvas()"></div>
  <div class="offcanvas-content">
    <div class="offcanvas-header">
      <h2 class="offcanvas-title">Menu</h2>
      <button class="offcanvas-close" (click)="closeOffcanvas()">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    </div>
    
    <nav class="offcanvas-nav">
      <ul class="offcanvas-menu">
        <li 
          *ngFor="let item of menuItems" 
          class="offcanvas-menu-item"
          [class.has-children]="item.children && item.children.length > 0"
          [class.dropdown-open]="isDropdownOpen(item.label)"
        >
          <!-- Parent item with dropdown -->
          <div 
            *ngIf="item.children && item.children.length > 0"
            class="offcanvas-menu-link offcanvas-menu-link--dropdown"
            (click)="toggleItemDropdown(item.label, $event)"
          >
            <span class="offcanvas-menu-icon" *ngIf="item.iconUrl || item.safeIcon">
              <img *ngIf="item.iconUrl" [src]="item.iconUrl" alt="" class="offcanvas-menu-icon-img" />
              <svg *ngIf="!item.iconUrl && item.safeIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <g [innerHTML]="item.safeIcon"></g>
              </svg>
            </span>
            <span class="offcanvas-menu-label">{{ item.label }}</span>
            <svg 
              class="offcanvas-dropdown-arrow"
              [class.rotated]="isDropdownOpen(item.label)"
              width="16" 
              height="16" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>
          
          <!-- Regular link item -->
          <a 
            *ngIf="!item.children || item.children.length === 0"
            [routerLink]="item.route"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{exact: false}"
            class="offcanvas-menu-link"
            (click)="handleMenuClick(item); closeOffcanvas()"
          >
            <span class="offcanvas-menu-icon" *ngIf="item.iconUrl || item.safeIcon">
              <img *ngIf="item.iconUrl" [src]="item.iconUrl" alt="" class="offcanvas-menu-icon-img" />
              <svg *ngIf="!item.iconUrl && item.safeIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <g [innerHTML]="item.safeIcon"></g>
              </svg>
            </span>
            <span class="offcanvas-menu-label">{{ item.label }}</span>
          </a>
          
          <!-- Dropdown children -->
          <ul 
            *ngIf="item.children && item.children.length > 0 && isDropdownOpen(item.label)"
            class="offcanvas-submenu"
          >
            <li 
              *ngFor="let child of item.children" 
              class="offcanvas-submenu-item"
            >
              <a 
                [routerLink]="child.route"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: false}"
                class="offcanvas-submenu-link"
                (click)="handleMenuClick(child); closeOffcanvas(); $event.stopPropagation()"
              >
                <span class="offcanvas-submenu-label">{{ child.label }}</span>
              </a>
            </li>
          </ul>
        </li>
        
        <!-- Call to Action as Menu Item in Offcanvas -->
        <li class="offcanvas-menu-item offcanvas-cta-item" *ngIf="callToAction">
          <a 
            *ngIf="callToAction.linkRoute"
            [routerLink]="callToAction.linkRoute"
            [class.active]="isOrganisationRouteActive()"
            class="offcanvas-menu-link offcanvas-cta-link"
            (click)="closeOffcanvas()"
          >
            <span class="offcanvas-menu-icon offcanvas-cta-icon-wrap" *ngIf="callToAction.iconUrl || callToAction.safeIcon">
              <img *ngIf="callToAction.iconUrl" [src]="callToAction.iconUrl" alt="" class="offcanvas-cta-icon-img" />
              <svg *ngIf="!callToAction.iconUrl && callToAction.safeIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <g [innerHTML]="callToAction.safeIcon"></g>
              </svg>
            </span>
            <span class="offcanvas-cta-content">
              <span class="offcanvas-cta-title">{{ callToAction.title }}</span>
              <span class="offcanvas-cta-description">{{ callToAction.description }}</span>
              <span class="offcanvas-cta-button-text" *ngIf="callToAction.linkText">{{ callToAction.linkText }} →</span>
            </span>
          </a>
          <a 
            *ngIf="callToAction.linkHref && !callToAction.linkRoute"
            [href]="callToAction.linkHref"
            class="offcanvas-menu-link offcanvas-cta-link"
            (click)="closeOffcanvas()"
          >
            <span class="offcanvas-menu-icon offcanvas-cta-icon-wrap" *ngIf="callToAction.iconUrl || callToAction.safeIcon">
              <img *ngIf="callToAction.iconUrl" [src]="callToAction.iconUrl" alt="" class="offcanvas-cta-icon-img" />
              <svg *ngIf="!callToAction.iconUrl && callToAction.safeIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <g [innerHTML]="callToAction.safeIcon"></g>
              </svg>
            </span>
            <span class="offcanvas-cta-content">
              <span class="offcanvas-cta-title">{{ callToAction.title }}</span>
              <span class="offcanvas-cta-description">{{ callToAction.description }}</span>
              <span class="offcanvas-cta-button-text" *ngIf="callToAction.linkText">{{ callToAction.linkText }} →</span>
            </span>
          </a>
          <div 
            *ngIf="!callToAction.linkRoute && !callToAction.linkHref"
            class="offcanvas-menu-link offcanvas-cta-link offcanvas-cta-link--disabled"
          >
            <span class="offcanvas-menu-icon offcanvas-cta-icon-wrap" *ngIf="callToAction.iconUrl || callToAction.safeIcon">
              <img *ngIf="callToAction.iconUrl" [src]="callToAction.iconUrl" alt="" class="offcanvas-cta-icon-img" />
              <svg *ngIf="!callToAction.iconUrl && callToAction.safeIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <g [innerHTML]="callToAction.safeIcon"></g>
              </svg>
            </span>
            <span class="offcanvas-cta-content">
              <span class="offcanvas-cta-title">{{ callToAction.title }}</span>
              <span class="offcanvas-cta-description">{{ callToAction.description }}</span>
            </span>
          </div>
        </li>
      </ul>
      
      <div class="offcanvas-footer-links">
        <a 
          *ngFor="let item of footerItems"
          [routerLink]="item.route ? [item.route] : null"
          [href]="item.href"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{exact: false}"
          class="offcanvas-menu-link"
          (click)="handleMenuClick(item); closeOffcanvas()"
        >
          <span class="offcanvas-menu-icon" *ngIf="item.iconUrl || item.safeIcon">
            <img *ngIf="item.iconUrl" [src]="item.iconUrl" alt="" class="offcanvas-menu-icon-img" />
            <svg *ngIf="!item.iconUrl && item.safeIcon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <g [innerHTML]="item.safeIcon"></g>
            </svg>
          </span>
          <span class="offcanvas-menu-label">{{ item.label }}</span>
        </a>
      </div>
    </nav>
  </div>
</div>
